import React from 'react';
import { certifications } from '../data/resume';
import './Certifications.css';

const issuerIcon = (issuer) => {
  if (issuer.includes('Google')) return '🟢';
  if (issuer.includes('Forage')) return '🔷';
  if (issuer === 'ISRO') return '🚀';
  if (issuer === 'Scaler') return '📊';
  return '🏅';
};

export default function Certifications() {
  return (
    <section id="certifications" className="section-wrap">
      <h2 className="section-title">Certifications</h2>
      <div className="certs-grid">
        {certifications.map((cert) => (
          <div className="cert-card" key={cert.name + cert.issuer}>
            <div className="cert-icon">{issuerIcon(cert.issuer)}</div>
            <div className="cert-info">
              <div className="cert-name">{cert.name}</div>
              <div className="cert-meta mono">
                <span className="cert-issuer">{cert.issuer}</span>
                <span className="cert-dot">·</span>
                <span className="cert-date">{cert.date}</span>
              </div>
              {cert.credentialId && (
                <div className="cert-id mono">ID: {cert.credentialId}</div>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
